import { Rule } from '@mui/icons-material';
import { Box, Card, CardContent, Stack, SxProps, Typography } from '@mui/material';
import React from 'react';
import { SquareChip } from '../chip/TypeChip';
import ScoreBar from '../score-bar/ScoreBar';
import { AssessmentScore } from '../types';

export interface AssessmentResultOverviewProps {
  criticalAchievement: number;
  criticalError: number;
  inProgress: boolean;
  limitScore: number;
  numberOfAchievements: number;
  scorePercent: number;
  sx?: SxProps;
}

const AssessmentResultOverview = ({
  criticalAchievement,
  criticalError,
  inProgress,
  limitScore,
  numberOfAchievements,
  scorePercent,
  sx = {},
}: AssessmentResultOverviewProps) => (
  <Card sx={sx}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <Rule sx={{ color: 'text.secondary' }} />
        <Typography variant="overline">Result overview</Typography>
      </Box>

      <ScoreBar inProgress={inProgress} limitPercentage={limitScore} percentage={scorePercent} />

      <Stack spacing={2}>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h6">Limit score</Typography> <SquareChip size="small" label={`${limitScore}%`} />
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h6">Critical error</Typography>
          <SquareChip
            label={criticalError}
            size="small"
            type={criticalError ? AssessmentScore.Negative : AssessmentScore.Positive}
          />
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h6">Critical achievement</Typography>
          <SquareChip
            label={`${criticalAchievement} / ${numberOfAchievements}`}
            size="small"
            type={criticalAchievement < numberOfAchievements ? AssessmentScore.Negative : AssessmentScore.Positive}
          />
        </Box>
      </Stack>
    </CardContent>
  </Card>
);

export default AssessmentResultOverview;
